import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import styled from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { getStyledText } from '../../helpers/styled';
import Config from '../../config';
export var BannerContainerVariant1 = withTheme(styled.div.withConfig({
  displayName: "style__BannerContainerVariant1",
  componentId: "sc-bcvl4-0"
})(["position:relative;background-color:", ";overflow:hidden;border-radius:", ";cursor:pointer;"], function (p) {
  return p.coreTheme.cl_white;
}, function (p) {
  return p.coreTheme.rad_xs;
}));
export var BannerContainerVariant2 = withTheme(styled.div.withConfig({
  displayName: "style__BannerContainerVariant2",
  componentId: "sc-bcvl4-1"
})(["position:relative;overflow:hidden;"]));
export var ContentWrapper = withTheme(styled.div.withConfig({
  displayName: "style__ContentWrapper",
  componentId: "sc-bcvl4-2"
})(["display:flex;padding:", "px;", ";"], function (p) {
  return p.coreTheme.space_3;
}, Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-right: ", "px;\n  "])), function (p) {
  return p.coreTheme.space_4;
})));
export var ContentText = styled.div.withConfig({
  displayName: "style__ContentText",
  componentId: "sc-bcvl4-3"
})(["display:flex;flex-direction:column;align-self:center;flex:1;min-width:0;"]);
export var TitleVariant1 = withTheme(getStyledText('boldBody', {
  lineHeight: 'compact'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  padding-left: ", "px;\n\n  ", ";\n\n  .highlight {\n    color: ", ";\n  }\n"])), function (p) {
  return p.coreTheme.cl_ter_base;
}, function (p) {
  return p.coreTheme.space_3;
}, Config.media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: ", "px;\n  "])), function (p) {
  return p.coreTheme.space_4;
}), function (p) {
  return p.coreTheme.cl_pri_d2;
}));
export var TitleVariant2 = withTheme(getStyledText('header')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  padding-left: ", "px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  .highlight {\n    color: ", ";\n  }\n"])), function (p) {
  return p.coreTheme.cl_ter_base;
}, function (p) {
  return p.coreTheme.space_4;
}, function (p) {
  return p.coreTheme.cl_pri_d2;
}));
export var ContentBody = withTheme(getStyledText('body', {
  lineHeight: 'compact'
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  padding-left: ", "px;\n"])), function (p) {
  return p.coreTheme.cl_ter_base;
}, function (p) {
  return p.coreTheme.space_4;
}));
export var IconWrapper = withTheme(styled.div.withConfig({
  displayName: "style__IconWrapper",
  componentId: "sc-bcvl4-4"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";width:56px;height:56px;border-radius:", ";flex:none;"], function (p) {
  return p.coreTheme.cl_pri_d2;
}, function (p) {
  return p.coreTheme.rad_xs;
}));